module.exports = __webpack_public_path__ + "static/media/Logo Yovie Music School .d7f3e2bb.jpeg";